/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotFormSaveOnEditQueryVariables = {
    orgRelayId: string;
    userIds: Array<string | null>;
    calendarIds: Array<string | null>;
};
export type AutopilotFormSaveOnEditQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"AutopilotFormSaveOnEdit_org">;
    } | null;
};
export type AutopilotFormSaveOnEditQuery = {
    readonly response: AutopilotFormSaveOnEditQueryResponse;
    readonly variables: AutopilotFormSaveOnEditQueryVariables;
};



/*
query AutopilotFormSaveOnEditQuery(
  $orgRelayId: ID!
  $userIds: [String]!
  $calendarIds: [String]!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...AutopilotFormSaveOnEdit_org_4lGh4F
    }
    id
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment AutopilotFormSaveOnEdit_org_4lGh4F on Org {
  ...AutopilotForm_org
  id
  experiments
  personsByUserIdsErrorable(userIds: $userIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotForm_org on Org {
  ...AutopilotFlexibility_org
  ...OrganizerAutopilotPausedFreemiumCallout_org
  id
  experiments
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OrganizerAutopilotPausedFreemiumCallout_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIds"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v4 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v5 = {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v11 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetCalendarId",
            "storageKey": null
        } as any,
        (v7 /*: any*/)
    ], v13 = [
        (v6 /*: any*/),
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "list",
                    "plural": true,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emails",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primaryEmail",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "givenName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "familyName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "externalImageUrl",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isYou",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "PersonList",
            "abstractKey": null
        } as any,
        {
            "kind": "InlineFragment",
            "selections": [
                (v9 /*: any*/)
            ],
            "type": "GraphEntityError",
            "abstractKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AutopilotFormSaveOnEditQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotFormSaveOnEdit_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AutopilotFormSaveOnEditQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "resolveOverrides",
                                            "value": false
                                        }
                                    ],
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "timeZone",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DayOverride",
                                                    "kind": "LinkedField",
                                                    "name": "dayOverrides",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "date",
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v7 /*: any*/)
                                    ],
                                    "storageKey": "userWorkingHours(resolveOverrides:false)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v10 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v10 /*: any*/),
                                                (v9 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "nextDefragTime",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "millis",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "DefragTime",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "SuggestedOrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SuggestedOrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedOrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v12 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "suggestedInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "OrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "pendingInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v12 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "pendingInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v5 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByUserIdsErrorable",
                                    "plural": false,
                                    "selections": (v13 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v4 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": (v13 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f4f5ed0bfb7998260d8b31904d90010f",
            "id": null,
            "metadata": {},
            "name": "AutopilotFormSaveOnEditQuery",
            "operationKind": "query",
            "text": "query AutopilotFormSaveOnEditQuery(\n  $orgRelayId: ID!\n  $userIds: [String]!\n  $calendarIds: [String]!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...AutopilotFormSaveOnEdit_org_4lGh4F\n    }\n    id\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_org_4lGh4F on Org {\n  ...AutopilotForm_org\n  id\n  experiments\n  personsByUserIdsErrorable(userIds: $userIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotForm_org on Org {\n  ...AutopilotFlexibility_org\n  ...OrganizerAutopilotPausedFreemiumCallout_org\n  id\n  experiments\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a4cd364c1b04b002dbaec7426d2d2244';
export default node;
